(ns manatee.admin.task-config.documents.subs
  "Task document data subscriptions."
  (:require
   [manatee.admin.task-config.documents.app-db :as db]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::uploading?
 (fn uploading?
   [db _]
   (db/uploading? db)))

(rf/reg-sub
 ::link-uploading?
 (fn link-uploading?
   [db _]
   (db/link-uploading? db)))

(rf/reg-sub
 ::documents
 (fn documents
   [db _]
   (db/get-documents db)))

(rf/reg-sub
 ::document-upload-payload
 (fn document-upload-payload
   [db _]
   (db/get-document-upload-payload db)))

(rf/reg-sub
 ::documentation-link-upload-payload
 (fn documentation-link-upload-payload
   [db _]
   (db/get-documentation-link-upload-payload db)))
